/**
 *
 * TimesItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import helmetIcon from '../../../../assets/icons/helmet.svg';
import horseIcon from '../../../../assets/icons/horse.svg';
// import starIcon from '../../../../assets/icons/star.svg';
import { Disciplines, LiveFeedEventTime } from '../../../../domain';

interface IProps {
  time: LiveFeedEventTime;
  disabledProps: string[];
  discipline: Disciplines;
}

const TimesItem: FunctionComponent<IProps> = ({
  time,
  disabledProps,
  discipline,
}) => {
  const isEnabled = (field: string) => {
    return !disabledProps.includes(field);
  };

  return (
    <>
      <tr>
        {/* <td width="30px">
          <div className="d-flex align-item-center justify-content-center">
            <img src={starIcon} alt="" />
          </div>
        </td> */}
        {isEnabled('drawnOrder') && <td width="30px">{time.drawnOrder}</td>}
        {isEnabled('class') && <td>{time.eaEventClassAndSort}</td>}
        {isEnabled('eaClassEntrySectionName') && (
          <td width="60px">{time.eaClassEntrySectionName}</td>
        )}
        {isEnabled('bridleNumber') && (
          <td>
            <div className="fw-7">{time.bridleNumber}</div>
          </td>
        )}
        {isEnabled('riderFullName') && (
          <td>
            <div className="d-flex align-items-center">
              <img src={helmetIcon} className="mr-11 tablet-hidden" alt="" />
              <div className="fs-12 fw-7">
                {time.riderFullName ? time.riderFullName : 'N/A'}
              </div>
            </div>
            <div className="fs-12 tablet-visible">{time.customHorseName}</div>
          </td>
        )}
        <td>
          <div className="d-flex align-items-center tablet-hidden">
            <img src={horseIcon} className="mr-11" alt="" />
            <div className="d-flex flex-column">
              <div className="fs-12 fw-7">{time.customHorseName}</div>
              <div className="fs-12">
                {time.ownerFullName ? `Owner: ${time.ownerFullName}` : 'N/A'}
              </div>
            </div>
          </div>
        </td>
        {isEnabled('dressageTime') && <td>{time.dressageTime}</td>}
        {isEnabled('showJumpingTime') && (
          <td>{time.showJumpingTime || time.dressageTime}</td>
        )}
        {isEnabled('riderClassStatusName') && (
          <td width="100px">
            <div className="fw-7  fs-12">{time.riderClassStatusCode}</div>
          </td>
        )}
      </tr>
      {time.breakTimeCustom && time.breakTimeCustom !== '00:00' && (
        <tr>
          <td colSpan={20}>
            <div className="d-flex align-item-center justify-content-center">
              <div className="table-decorated-cell">
                <div className="txt fs-12 fw-7 txt-accent">
                  {time.breakTimeCustom}
                </div>
                <div className="txt fs-12 fw-7 txt-accent">
                  {time.breakTimeName}
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );

  // return (
  //   <>
  //     <StyledCard ref={ref} className="mt-10 mb-10">
  //       <div className="card-body">
  //         <div className="row">
  //           <div className="col-2">
  //             {isEnabled('bridleNumber') && (
  //               <>
  //                 <div className="fw-7">{time.bridleNumber}</div>
  //                 <div className="txt txt-secondary fs-11">Rider/BN</div>
  //               </>
  //             )}
  //           </div>
  //           <div className="col-7">
  //             {isEnabled('class') && (
  //               <div className="mb-10">
  //                 <div className="txt">{time.eaEventClassAndSort}</div>
  //                 <div className="txt txt-secondary fs-11">Class</div>
  //               </div>
  //             )}
  //             {isEnabled('eaClassEntrySectionName') && (
  //               <>
  //                 <div className="txt">{time.eaClassEntrySectionName}</div>
  //                 <div className="txt txt-secondary fs-11">Section</div>
  //               </>
  //             )}
  //             <div className="d-flex mt-15">
  //               <img src={helmetIcon} className="mr-11" alt="" />
  //               <div className="fs-12 fw-7">{time.riderFullName}</div>
  //             </div>
  //             <div className="d-flex align-items-center">
  //               <img src={horseIcon} className="mr-11" alt="" />
  //               <div>
  //                 <div className="fs-12 fw-7">{time.customHorseName}</div>
  //                 <div className="fs-12">Owner: {time.ownerFullName}</div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-3 txt-right">
  //             {isEnabled('riderClassStatusName') && (
  //               <>
  //                 <p className="txt fw-7 txt-accent name">
  //                   {time.riderClassStatusCode}
  //                 </p>
  //                 <p className="txt txt-secondary fs-11">Status</p>
  //               </>
  //             )}
  //             {isEnabled('drawnOrder') && (
  //               <>
  //                 <p className="txt fw-7">{time.drawnOrder}</p>
  //                 <p className="txt txt-secondary fs-11">Drawn order</p>
  //               </>
  //             )}
  //           </div>
  //         </div>
  //         <div className="row">
  //           <div className="col-2"></div>
  //           {isEnabled('showJumpingTime') && (
  //             <div className="col-5">
  //               <p className="txt fw-7 mt-15">{time.showJumpingTime || '-'}</p>
  //               <p className="txt txt-secondary fs-11">
  //                 {discipline === Disciplines.Showjumping ? 'Time' : 'SJ Time'}
  //               </p>
  //             </div>
  //           )}
  //           {isEnabled('dressageTime') && (
  //             <div className="col-5">
  //               <p className="txt mt-15 fw-7">{time.dressageTime || '-'}</p>
  //               <p className="txt txt-secondary fs-11">
  //                 {discipline === Disciplines.Dressage ? 'Time' : 'DR Time'}
  //               </p>
  //             </div>
  //           )}
  //         </div>
  //       </div>
  //     </StyledCard>
  //     {time.breakTimeCustom && time.breakTimeCustom !== '00:00' && (
  //       <div className="d-flex align-item-center justify-content-center">
  //         <div className="table-decorated-cell">
  //           <div className="txt fs-12 fw-7 txt-accent">
  //             {time.breakTimeCustom}
  //           </div>
  //           <div className="txt fs-12 fw-7 txt-accent">
  //             {time.breakTimeName}
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </>
  // );
};

export default memo(TimesItem);
